module.exports = __webpack_public_path__ + "static/media/currency-ytd.3e9a10ff.svg";